
export enum NotificationType {

	SUCCESS = 0, 
	INFO = 1, 
	WARNING = 2, 
	DANGER = 3

}